import React from "react";
import { connect } from "react-redux";

import { openModal, updateAnimation } from "../../../../../../../actions/shared/uiActions";
import Button from "../../../../../../forms/custom/Button";
import RestoreModal from "../modals/RestoreModal";

function RestoreButton({
  candidate,
  openModal,
  overrideStyle,
  overloadedClasses,
  updateCardExitAnimation
}) {
  const handleClick = () => {
    updateCardExitAnimation();
    openModal(<RestoreModal candidate={candidate} />);
  };

  return (
    <Button
      color="blue"
      variant="primary"
      onClick={handleClick}
      style={overrideStyle || {}}
      overloadedClasses={
        overloadedClasses
          ? overloadedClasses.concat(["restoreButton"])
          : []
      }
      data-cy="restore-button"
    >
      Restore
    </Button>
  );
}

RestoreButton.defaultProps = {
  toggleAnimation: () => { }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateCardExitAnimation: () => dispatch(
    updateAnimation(`candidate-card-${ownProps.candidate.id}`, {
      exit: "bounceOutRight"
    })
  ),
  openModal: content => dispatch(openModal(content))
});

export default connect(
  null,
  mapDispatchToProps
)(RestoreButton);
